import React from "react";
import { HelpCircle } from "lucide-react";

// Accessible FAQ list; pairs with FAQPage JSON-LD emitted by the page's <Seo />.
export default function Faq({ items, title = "Frequently asked questions", subtitle }) {
  return (
    <section className="mx-auto max-w-4xl px-5 py-16" data-testid="faq-section">
      <div className="flex items-center gap-2 text-blue-600"><HelpCircle className="h-5 w-5" /><span className="text-sm font-semibold uppercase tracking-wide">FAQ</span></div>
      <h2 className="mt-2 text-2xl font-bold text-slate-900 md:text-3xl">{title}</h2>
      {subtitle && <p className="mt-2 max-w-2xl text-slate-600">{subtitle}</p>}
      <dl className="mt-8 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
        {items.map((f, i) => (
          <details key={f.q} className="group px-5 py-4" open={i === 0} data-testid="faq-item">
            <summary className="cursor-pointer list-none text-base font-semibold text-slate-900 marker:hidden">
              <dt className="flex items-center justify-between gap-4">{f.q}<span className="text-slate-400 transition-transform group-open:rotate-45">+</span></dt>
            </summary>
            <dd className="mt-2 text-sm leading-relaxed text-slate-600">{f.a}</dd>
          </details>
        ))}
      </dl>
    </section>
  );
}

export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});
